// import { ProductManagement } from 'product-management/productManagement';
import { Redirect } from 'react-router-dom';
import { ROUTES } from 'routing';

export function ProductManagementResolver() {
  return <Redirect to={ROUTES.login} />;

  // return <ProductManagement />;
}
